<script>
import { cloneDeep } from 'lodash-es';
import NavigationService from '../../../services/navigation-service';
import ItineraryPricesPriceSettingsHotelModal from './ItineraryPricesPriceSettingsHotelModal';
import ItineraryPricesPriceSettingsSupplierModal from './ItineraryPricesPriceSettingsSupplierModal';
import ItineraryPricesPriceSettingsDiscountModal from './ItineraryPricesPriceSettingsDiscountModal';
import ItineraryPricesCategories from '../../../variables/itineraryPrices/itineraryPricesCategories';

export default {
  name: 'ItineraryPricesPriceSettingsTableRow',
  components: {
    ItineraryPricesPriceSettingsHotelModal,
    ItineraryPricesPriceSettingsSupplierModal,
    ItineraryPricesPriceSettingsDiscountModal,
  },
  props: {
    props: {
      type: Object,
      required: false,
    },
    extendedRow: {
      type: Boolean,
      default: false,
    },
    extraRow: {
      type: Boolean,
      default: false,
    },
    packageRow: {
      type: Boolean,
      default: false,
    },
    paxHeaders: {
      type: Array,
      required: true,
    },
    ageDiscountPaxes: {
      type: Array,
      default: () => [],
    },
    setting: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    hotelIndex: {
      type: Number,
      default: 0,
    },
    day: {
      type: Number,
      default: null,
    },
    date: {
      type: String,
      default: '',
    },
    availableHotels: {
      type: Array,
      default: () => [],
    },
    suppliers: {
      type: Array,
      required: true,
    },
    priceSettings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      NavigationService,
      localSetting: null,
      isGroup: false,
      localFilteredPrices: [],
      localPackageSupplier: null,
    };
  },
  watch: {
    setting: {
      deep: true,
      immediate: true,
      handler(value) {
        this.localSetting = cloneDeep(value);
        if (this.paxHeaders) {
          this.filteredPrices(this.paxHeaders);
        }
      },
    },
    localSetting: {
      deep: true,
      handler() {
        this.$emit('update', this.localSetting);
      },
    },
    paxHeaders: {
      deep: true,
      immediate: true,
      handler(value) {
        this.filteredPrices(value);
      },
    },
  },
  computed: {
    formattedDate() {
      if (this.date) {
        return this.$moment(this.date, 'YYYY-MM-DD').format('DD/MM YYYY');
      }
      return null;
    },
    disabled() {
      return !this.packageRow && !this.extraRow && !this.availableHotels.length && this.priceSettings.description;
    },
  },
  methods: {
    setHotelAndRoom(value) {
      this.localSetting.site = value.hotel;
      if (value.room) {
        this.localSetting.accommodation = value.room;
        this.localSetting.accommodationSiteId = value.room.accommodationSiteId;
        this.setSupplier(value.room.supplier);
      }
      this.priceSettings.hotels.forEach((hotel, index) => {
        if (hotel.site) {
          if (index !== this.index && hotel.site.siteId === value.hotel.siteId) {
            this.localSetting.category = ItineraryPricesCategories.CATEGORY_A;
            this.localSetting.included = true;
          }
        }
      });
      this.$emit('auto-set-site', value);
    },
    setSupplier(supplier) {
      this.localSetting.setting.supplier = supplier;
    },
    saveDiscounts(value) {
      this.$emit('setDiscounts', { siteIndex: this.hotelIndex, discounts: value });
    },
    filteredPrices(paxes) {
      let filteredPrices = [];
      paxes.forEach((paxHeader) => {
        const paxValues = paxHeader.text.split('-');
        this.isGroup = paxValues.length > 1;
      });

      if (this.isGroup) {
        filteredPrices = this.localSetting.setting.prices.filter(price => price.paxFrom !== price.paxTo);
      } else {
        filteredPrices = this.localSetting.setting.prices.filter(price => price.paxFrom === price.paxTo);
      }
      this.localFilteredPrices = filteredPrices.sort((a, b) => a.priceKey - b.priceKey);
    },
    setPrice(key, value) {
      this.localSetting.setting.prices.forEach((element) => {
        if (key === element.priceKey) {
          element.price = value !== '' ? +value : null;
        }
      });
      const noPrices = this.localSetting.setting.prices.every(element => element.price === null);
      if (this.localSetting.setting.accommodation && !noPrices) {
        this.localSetting.setting.supplier = this.localSetting.setting.accommodation.supplier;
      }
      if (noPrices) {
        this.$emit('no-prices');
      }
    },
    setMinCurrency(event) {
      this.localSetting.setting.currency.min = this.getInfo(event.target.value);
    },
    setMaxCurrency(event) {
      this.localSetting.setting.currency.max = this.getInfo(event.target.value);
    },
    setSingleRoomSupplement(value) {
      this.localSetting.singleRoomSupplementPrice = this.getInfo(value);
    },
    getInfo(value) {
      return value !== '' ? +value : null;
    },
    updateInfo(value, attribute) {
      this.localSetting.setting[attribute] = this.getInfo(value);
    },
    resetPrices() {
      const resetPrices = this.localSetting.setting.prices.map(({ price, ...prices }) => ({ ...prices, price: null }));
      this.localSetting.setting.prices = [...resetPrices];
      this.filteredPrices(this.paxHeaders);
    },
  },
};
</script>

<template>
  <tr class="text-xs-left">
    <td class="text-xs-left ma-0 pa-0">
      <div v-if="!extraRow && !packageRow">
        {{ day + 1 }} | {{ formattedDate }}
      </div>
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <v-checkbox
        v-if="!packageRow"
        v-model="localSetting.included"
        :disabled="extraRow"
        class="pt-2"
        hide-details
      />
    </td>
    <td class="text-xs-center ma-0 pa-0">
      <v-btn
        v-if="!packageRow && !extraRow && priceSettings.carRental && priceSettings.carRental.length"
        flat
        icon
        color="blue-grey darken-4"
      >
        <v-icon>car_rental</v-icon>
      </v-btn>
      <template v-if="!packageRow && !extraRow">
        <itinerary-prices-price-settings-hotel-modal
          v-if="availableHotels.length"
          :hotels="availableHotels"
          :price-settings="priceSettings"
          :index="index"
          :hotel-index="hotelIndex"
          :date="date"
          :site="localSetting.site"
          :accommodation="localSetting.accommodation"
          @update="setHotelAndRoom($event)"
        />
      </template>
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <div v-if="!packageRow && !extraRow && availableHotels.length">
        <a
          v-if="localSetting.site"
          :href="NavigationService.sitePage(localSetting.site.id)"
          target="__blank"
          class="hotel-text"
        >
          {{ localSetting.site.name }}
        </a>
        <span v-else>Select hotel</span>
        <br />
        <a
          v-if="localSetting.accommodation"
          :href="NavigationService.accommodationPage(localSetting.accommodation.id)"
          target="__blank"
          class="hotel-text"
        >
          {{ `${localSetting.accommodation.name}
            (${localSetting.accommodation.maxAges.join(', ').replace(/999/g, 'A')})`
          }}
        </a>
        <span v-else>Select room</span>
      </div>
      <div v-if="extraRow">
        <div>({{ localSetting.category }})</div>
        {{ localSetting.name }}
      </div>
      <div v-if="packageRow">
        {{ localSetting.category }}
      </div>
      <div v-if="!packageRow && !extraRow && !availableHotels.length && priceSettings.description">
        {{ priceSettings.description }}
      </div>
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <div v-if="!packageRow && !extraRow">
        <select
          v-model="localSetting.category"
          :disabled="extraRow || disabled"
          name="classSelection"
          class="table-input"
        >
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
        </select>
      </div>
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.singleRoomSupplementPrice"
        :disabled="disabled"
        type="number"
        step="0.01"
        class="table-input"
        @input="setSingleRoomSupplement($event.target.value)"
      />
    </td>
    <td
      v-for="(localFilteredPrice, index) in localFilteredPrices"
      :key="`customer-pax-headers-${index}`"
      class="text-xs-left ma-0 pa-0"
    >
      <input
        :value="localFilteredPrice.price"
        :disabled="disabled"
        type="number"
        step="0.01"
        class="table-input"
        @input="setPrice(localFilteredPrice.priceKey, $event.target.value)"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.commissionRatio"
        :disabled="disabled"
        type="number"
        step="0.01"
        class="table-input"
        @input="updateInfo($event.target.value, 'commissionRatio')"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.contributionRatio"
        :disabled="disabled"
        type="number"
        step="0.01"
        class="table-input"
        @input="updateInfo($event.target.value, 'contributionRatio')"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.supplierGrossPrice"
        disabled
        type="number"
        step="0.01"
        class="table-input"
        @input="updateInfo($event.target.value, 'supplierGrossPrice')"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.pricePerPerson"
        disabled
        type="number"
        step="0.01"
        class="table-input"
        @input="updateInfo($event.target.value, 'pricePerPersonExchanged')"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.currency.min"
        :disabled="disabled"
        type="number"
        step="0.01"
        class="table-input"
        @input="setMinCurrency"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.currency.max"
        :disabled="disabled"
        type="number"
        step="0.01"
        class="table-input"
        @input="setMaxCurrency"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <itinerary-prices-price-settings-discount-modal
        :discount-paxes="localSetting.setting.discounts"
        @update="saveDiscounts($event)"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <itinerary-prices-price-settings-supplier-modal
        :suppliers="suppliers"
        :selected-supplier="localSetting.setting.supplier"
        @update="setSupplier($event)"
        @reset-prices="resetPrices"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <v-icon
        v-if="extendedRow"
        :disabled="extraRow"
        color="red darken-2"
        @click="$emit('delete', index)"
      >
        delete
      </v-icon>
      <div v-if="!extendedRow && !packageRow">
        <div @click="props.expanded = !props.expanded" class="expander">
          <v-icon v-if="!props.expanded">expand_more</v-icon>
          <v-icon v-else>expand_less</v-icon>
        </div>
      </div>
    </td>
  </tr>
</template>

<style lang="scss">
  @import '../../../assets/scss/variables';

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .hotel-text {
    font-size: 12px;
  }

  .expander {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesPriceSettingsTableRow.vue